import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Seo } from "../components/Seo";
import { Footer } from "../components/Footer";
import { DESTINATIONS } from "../data/destinations";
import { ArrowRight } from "lucide-react";

export default function Destinations() {
  const navigate = useNavigate();
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "WanderlyMe Destination Guides",
    itemListElement: DESTINATIONS.map((d, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: `https://wanderlyme.com/destinations/${d.slug}`,
      name: `${d.name}, ${d.country}`,
    })),
  };
  return (
    <div className="min-h-screen grain relative">
      <Seo
        title="Destination Guides"
        description="Explore WanderlyMe's curated destination guides — best times to visit, must-see highlights and sample day-by-day itineraries for cities around the world."
        path="/destinations"
        jsonLd={jsonLd}
      />
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 py-12">
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-2">Destination guides</h1>
        <p className="text-muted-foreground mb-10 max-w-2xl">
          Hand-picked guides with the best time to visit, top highlights and a sample itinerary — then generate a
          personalised plan in seconds.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {DESTINATIONS.map((d) => (
            <div
              key={d.slug}
              data-testid={`destination-card-${d.slug}`}
              onClick={() => navigate(`/destinations/${d.slug}`)}
              className="group cursor-pointer rounded-2xl overflow-hidden border border-black/5 bg-white/60 hover:-translate-y-1 hover:shadow-md transition-all"
            >
              <img src={d.image} alt={`${d.name}, ${d.country}`} className="h-44 w-full object-cover" loading="lazy" />
              <div className="p-6">
                <p className="text-xs uppercase tracking-widest text-[#C8553D] mb-1">{d.country}</p>
                <h2 className="font-display text-2xl leading-tight">{d.name}</h2>
                <p className="text-muted-foreground text-sm mt-2 line-clamp-2">{d.tagline}</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-[#F3EFE8]">{d.tripLength}</span>
                  <span className="text-xs px-2.5 py-1 rounded-full bg-[#F3EFE8]">{d.region}</span>
                </div>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[#1A3B2B] group-hover:text-[#C8553D] transition-colors">
                  Read guide <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
